// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header, .footer {
  background-color: #ffffff;
  color: black;
  text-align: center;
  padding: 10px 0;
}

.flex-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
}

.main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  padding: 20px;
  box-sizing: border-box;
  margin: 0px 0px 145nppx 0px;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
}

.login-container {
  display: flex;
  align-items: center;
  background: white;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
  justify-content: space-evenly;
  flex-wrap: wrap; 
  flex-direction: column; 
}

.logo-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
}

.logo-section img {
  max-width: 200px;
}

.divider {
  width: 100%;
  height: 1px;
  background: #ccc;
  margin: 20px 0;
}

.login-form-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-form-section h2 {
  margin-bottom: 20px;
}

.input-group-login{
  margin-bottom: 15px;
  width: 100%;
  /* border-color: #000000; */
}

.input-group-login label {
  display: block;
  margin-bottom: 5px;
  /* border-color: #000000; */
}

.input-group-login input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  font-family: 'Century Schoolbook';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  /* border-color: #000000; */
}

.input-group-login input:focus {
  border: 2px solid #2865aa;
  outline: none;
}

.log {
  padding: 10px;
  background-color: #2865aa;
  border: none;
  color: white;
  cursor: pointer;
  width: 100%;
  border-radius: 5px;
}

.log :hover {
  background-color: #0056b3;
}

.forgot-password {
  display: block;
  margin-top: 10px;
  color: #007BFF;
  text-decoration: none;
  font-size: 12px;
  font-family: 'Century Schoolbook';
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.forgot-password:hover {
  text-decoration: underline;
}

.footer {
  background-color: #ffffff;
  color: black;
  text-align: center;
  padding: 10px 0;
  margin-top: auto; 
}

.footer-content {
  padding: 10px 20px;
}

@media (min-width: 768px) {
  .login-container {
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .logo-section {
    margin-bottom: 0;
  }

  .divider {
    width: 2px;
    height: 300px;
    margin: 0 25px;
  }

  .login-form-section {
    max-width: none;
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":["\n.header, .footer {\n  background-color: #ffffff;\n  color: black;\n  text-align: center;\n  padding: 10px 0;\n}\n\n.flex-wrapper {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.main {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  padding: 20px;\n  box-sizing: border-box;\n  margin: 0px 0px 145nppx 0px;\n}\n\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.login-container {\n  display: flex;\n  align-items: center;\n  background: white;\n  padding: 20px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 800px;\n  box-sizing: border-box;\n  justify-content: space-evenly;\n  flex-wrap: wrap; \n  flex-direction: column; \n}\n\n.logo-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n.logo-section img {\n  max-width: 200px;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background: #ccc;\n  margin: 20px 0;\n}\n\n.login-form-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.login-form-section h2 {\n  margin-bottom: 20px;\n}\n\n.input-group-login{\n  margin-bottom: 15px;\n  width: 100%;\n  /* border-color: #000000; */\n}\n\n.input-group-login label {\n  display: block;\n  margin-bottom: 5px;\n  /* border-color: #000000; */\n}\n\n.input-group-login input {\n  width: 100%;\n  padding: 8px;\n  box-sizing: border-box;\n  font-family: 'Century Schoolbook';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  /* border-color: #000000; */\n}\n\n.input-group-login input:focus {\n  border: 2px solid #2865aa;\n  outline: none;\n}\n\n.log {\n  padding: 10px;\n  background-color: #2865aa;\n  border: none;\n  color: white;\n  cursor: pointer;\n  width: 100%;\n  border-radius: 5px;\n}\n\n.log :hover {\n  background-color: #0056b3;\n}\n\n.forgot-password {\n  display: block;\n  margin-top: 10px;\n  color: #007BFF;\n  text-decoration: none;\n  font-size: 12px;\n  font-family: 'Century Schoolbook';\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.forgot-password:hover {\n  text-decoration: underline;\n}\n\n.footer {\n  background-color: #ffffff;\n  color: black;\n  text-align: center;\n  padding: 10px 0;\n  margin-top: auto; \n}\n\n.footer-content {\n  padding: 10px 20px;\n}\n\n@media (min-width: 768px) {\n  .login-container {\n    flex-direction: row;\n    flex-wrap: nowrap;\n  }\n\n  .logo-section {\n    margin-bottom: 0;\n  }\n\n  .divider {\n    width: 2px;\n    height: 300px;\n    margin: 0 25px;\n  }\n\n  .login-form-section {\n    max-width: none;\n    width: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
